import { render, staticRenderFns } from "./ContactListCellRendererTags.vue?vue&type=template&id=4728e62e&scoped=true&"
import script from "./ContactListCellRendererTags.vue?vue&type=script&lang=js&"
export * from "./ContactListCellRendererTags.vue?vue&type=script&lang=js&"
import style0 from "./ContactListCellRendererTags.vue?vue&type=style&index=0&id=4728e62e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4728e62e",
  null
  
)

export default component.exports